import styles from "./tournaments-list.module.css"
import { TTournament } from "../types"

type TArgTournamentsList = {
    tournaments: TTournament[],
    onDoubleClick: ((tournamentId: string) => void),
}

export const TournamentsList = ({
    tournaments,
    onDoubleClick
}: TArgTournamentsList) => {
    return (
        <div className={styles.App}>
            {tournaments.map((tournament) => (
                <div className={styles.Tournament} onDoubleClick={() => onDoubleClick(tournament.id)}>
                    <div>
                        <div>{tournament.name}</div>
                        <div>
                            <div>{tournament.type}</div>
                            <div>{tournament.gamers}</div>
                        </div>
                    </div>
                    <div>
                        <div>{tournament.completeDate}</div>
                        <div>{tournament.startDate}</div>
                    </div>
                </div>
            ))}
        </div>
    )
}